/* @flow */
import * as React from 'react';

// Styles
import styles from './BraindateParticipantsTable.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { getUserId } from '@braindate/domain/lib/user/util';

// Components

// Types
import type { BraindateParticipantListElement } from './BraindateParticipants';
import type { User } from '@braindate/domain/lib/user/type';
import BraindateParticipantsItem from './elements/BraindateParticipantsItem';
import { useDispatch } from 'react-redux';
import useEventId from 'src/shared/domain/event/hook/useEventId';
import { fetchUserTopics } from 'src/shared/domain/topic/action/topicActions';
import { fetchUser } from 'src/shared/domain/user/action/userActions';
import classNames from 'classnames';

type Props = {
  participant: User,
  columns: BraindateParticipantListElement[],
  onClose: () => void,
};

const useStyles = createUseThemeStyles(styles);

const BraindateParticipantsTableRow = ({
  participant,
  columns,
  onClose,
}: Props) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const eventId = useEventId();

  React.useEffect(() => {
    dispatch(fetchUserTopics(eventId, getUserId(participant), { limit: 1 }));
    dispatch(fetchUser(getUserId(participant), eventId));
  }, []);

  return (
    <>
      {columns.map((column, key, center) => (
        <BraindateParticipantsItem
          column={column}
          participant={participant}
          onClose={onClose}
          render={(child) => (
            <td
              className={classNames(classes.tableCell, {
                [classes.tableCellCentered]: center,
              })}
            >
              {child}
            </td>
          )}
          key={`participant-${getUserId(participant)}-${key}`}
        />
      ))}
    </>
  );
};

export default React.memo<Props>(BraindateParticipantsTableRow);
